import { FC, useState } from "react";
import { Row, Col } from "antd";
import styles from "./BuildingTable.module.scss";
import { IconButton } from "../../../../ui-kit/IButton/IconButton/IconButton";
import nsiOrgStore from "../../../../store/nsiOrganizationsStore";
import { ConfirmModal, ExpandedTable, Spinner } from "../../../../ui-kit";

import BuildingForm from "../BuildingForm/BuildingForm";
import { observer } from "mobx-react-lite";
import HistoryModal from "../../../../ui-kit/HistoryModal/HistoryModal";
import { emptyBuilding } from "../initData";
import classnames from "classnames";

const BuildingsTable: FC<{ organization }> = observer(({ organization }) => {
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [buildingHistory, setBuildingHistory] = useState({ id: 0, name: "" });
  const [openNewBuildingForm, setOpenNewBuildingForm] = useState(false);
  const [deleteIdBuilding, setDeleteIdBuilding] = useState<number | null>(null);

  const columns = [
    {
      title: "Наименование здания",
      dataIndex: "name",
      key: "name",
      width: "25%",
      className: "align-left",
    },
    {
      title: "Адрес",
      dataIndex: "addressText",
      key: "addressText",
      width: "20%",
      className: "align-left",
    },
    {
      title: "Вид собственности",
      render: (text, record, index) => {
        if (!record.ownershipTypeId) return "";

        const ownershipType = nsiOrgStore.ownershipTypeList.find(
          (item) => item.id === record.ownershipTypeId,
        );

        if (!ownershipType) return "";

        return ownershipType.title;
      },
      key: "name",
    },
    {
      title: "",
      dataIndex: "actions",
      render: (_, record) => (
        <Row gutter={10}>
          <Col>
            <IconButton
              typeIcon={"edit"}
              variant="text"
              className={classnames(["action-button", styles.actionButton])}
            />
          </Col>
          {/* <Col>
            <IconButton
              typeIcon={"history"}
              variant="text"
              className={classnames(["action-button", styles.actionButton])}
              onClick={(e) => {
                e.stopPropagation();
                setBuildingHistory(record);
                setOpenHistoryModal(true);
              }}
            />
          </Col> */}
          <Col>
            <IconButton
              typeIcon={"delete"}
              variant="text"
              className={classnames(["action-button", styles.actionButton])}
              onClick={(e) => {
                e.stopPropagation();
                setDeleteIdBuilding(record.id);
              }}
            />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      {!nsiOrgStore.buildingsLoading && (
        <IconButton
          onClick={() => setOpenNewBuildingForm(!openNewBuildingForm)}
          typeIcon="add"
        >
          Добавить здание
        </IconButton>
      )}

      {openNewBuildingForm && (
        <BuildingForm
          record={{
            ...emptyBuilding,
            organizationMainId: organization.id,
            organizationMainName: organization.name,
          }}
          closeForm={() => setOpenNewBuildingForm(!openNewBuildingForm)}
        />
      )}

      {nsiOrgStore.buildingsLoading ? (
        <Spinner />
      ) : (
        <ExpandedTable
          columns={columns}
          data={organization?.buildings}
          rowKey={(record) => record.id}
          rowKeys={organization?.rowKeys?.keys}
          setRowKeys={(rows) => {
            organization?.rowKeys?.setKeys(rows);
          }}
          loading={nsiOrgStore?.buildingsLoading}
        >
          <BuildingForm
            record
            closeForm={(id) => organization?.rowKeys?.remove(id)}
          />
        </ExpandedTable>
      )}
      {openHistoryModal && (
        <HistoryModal
          title={buildingHistory?.name}
          open={openHistoryModal}
          onCancel={() => setOpenHistoryModal(false)}
          historyUrl={`/Orgstructure/BuildingMain/${buildingHistory.id}/History`}
          width="fit-content"
        />
      )}
      <ConfirmModal
        title="Удаление здания"
        message="Вы действительно хотите удалить здание?"
        visible={!!deleteIdBuilding}
        onClose={() => setDeleteIdBuilding(null)}
        onConfirm={() => {
          nsiOrgStore
            .deleteBuilding(deleteIdBuilding)
            .then((buildingDeleted) => {
              console.log("As");
              if (buildingDeleted) {
                console.log("buildingDeleted===true");
                organization.buildings = organization.buildings.filter(
                  (item) => item.id !== deleteIdBuilding,
                );
              }
            });
          setDeleteIdBuilding(null);
        }}
      />
    </div>
  );
});

export default BuildingsTable;
